import type { FaqItem } from '../../types';

export const FAQ_DATA: FaqItem[] = [
  {
    question: '서비스 이용 시 여러 캐릭터를 동시에 플레이할 수 있나요?',
    answer:
      '코드 입력 후 원하는 캐릭터를 선택하여 플레이할 수 있습니다. 3시간의 이용 시간 내에서는 자유롭게 캐릭터 변경이 가능합니다.',
  },
  {
    question: '이용 시간은 어떻게 확인할 수 있나요?',
    answer:
      '서비스 화면 상단의 타이머를 통해 남은 시간을 확인할 수 있습니다. 또한 이용 시간 만료 10분 전에는 알림 팝업으로 미리 안내해 드립니다.',
  },
  {
    question: '이용 시간이 만료되면 어떻게 되나요?',
    answer:
      '총 3시간의 이용 시간이 만료되면 더 이상 서비스를 이용하실 수 없습니다. 이용 시간은 최초 접속 시점부터 계산됩니다.',
  },
  {
    question: '서비스 사용 도중 오류가 발생하면 어떻게 해야 하나요?',
    answer:
      '네트워크 문제나 서버 오류로 서비스가 일시 중단될 수 있습니다. 브라우저를 새로고침하거나 다시 접속해 보세요. 문제가 지속될 경우 고객센터로 문의해 주시기 바랍니다. 오류로 인해 중단된 시간만큼은 이용 시간에서 차감되지 않습니다.',
  },
  {
    question: '캐릭터와 플레이한 모든 내용이 저장되나요?',
    answer:
      '서비스 품질 향상을 위해 이용 기록이 수집 및 관리되나, 이는 통계적인 목적으로만 활용됩니다. 성명, 연락처 등 개인정보는 일절 수집되지 않으니 안심하고 이용하시기 바랍니다.',
  },
];
